var _circle, _path, _path2, _g, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalUnits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2841,
    cy: 35.7841,
    r: 35.2841,
    fill: "#6E87A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2628 30.2344L13.6287 35.314V53.0928L26.4333 55.6326L34.0712 50.553V48.0119L26.4333 53.0928V50.4514L34.0712 45.373V42.9335L26.4333 48.0119V45.373L34.0712 40.2921V37.8526L26.4333 42.9335V40.2921L34.0712 35.2124V32.7742L21.2628 30.2344ZM16.1897 43.8123V38.3618L23.8737 39.8794V45.3298L16.1897 43.8123Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3275_25097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 22,
    width: 22,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4707 30.4769L24.9808 27.9789L32.4747 22.9829L45.9014 25.4809V43.2791L37.4707 48.8995V30.4769Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3275_25097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4137 22.8018L24.7796 27.8814V45.6602L37.5842 48.2L45.2221 43.1203V40.5792L37.5842 45.6602V43.0187L45.2221 37.9404V35.5009L37.5842 40.5792V37.9404L45.2221 32.8595V30.42L37.5842 35.5009V32.8595L45.2221 27.7798V25.3416L32.4137 22.8018ZM27.3406 36.3797V30.9292L35.0246 32.4467V37.8972L27.3406 36.3797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3275_25097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 15,
    width: 22,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7111 22.9818L36.2212 20.4838L43.7151 15.4878L57.1418 17.9858V35.784L48.7111 41.4044V22.9818Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3275_25097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5636 15.3672L35.9296 20.4468V38.2256L48.7341 40.7654L56.372 35.6858V33.1447L48.7341 38.2256V35.5842L56.372 30.5058V28.0663L48.7341 33.1447V30.5058L56.372 25.4249V22.9854L48.7341 28.0663V25.4249L56.372 20.3452V17.907L43.5636 15.3672ZM38.4905 28.9451V23.4946L46.1745 25.0122V30.4626L38.4905 28.9451Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUnits);
export default __webpack_public_path__ + "static/media/totalUnits.00c41236cf29202f9cc9198bf01bc660.svg";
export { ForwardRef as ReactComponent };